<template>
    <div>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="perm_perfilacessotelas.create && perm_perfilacessotelas.update"
                    @click="savePerfil"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div v-if="showContexto">
            <div class="columns is-flex-wrap pt-1">
                <div class="column is-4" v-for="(app_modulo, j) in app_moduloList" :key="j">
                    <div class="modulo-container">
                        <b-collapse
                            class="modulo-collapse"
                            animation="slide"
                            v-model="app_modulo.isOpen"
                            @open="onOpen(app_modulo, app_modulo.isOpen)"
                            @close="onOpen(app_modulo, app_modulo.isOpen)"
                        >
                            <div
                                slot="trigger"
                                class="module-title-block"
                                :class="app_modulo.isOpen ? ' modulo-opened ' : ''"
                                role="button"
                                aria-controls="contentIdForA11y2"
                            >
                                <div class="left">
                                    {{ $t(app_modulo.nome) }}
                                </div>
                                <div class="right">
                                    <div class="number-box">
                                        {{ app_modulo.countSelected }}
                                    </div>
                                    <div class="icon-box">
                                        <b-icon
                                            :icon="app_modulo.isOpen ? 'menu-down' : 'menu-left'"
                                        ></b-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="checkbox-group" v-if="app_modulo.isOpen">
                                <div class="group-search" v-if="app_modulo.app_telaList.length > 5">
                                    <search-bar
                                        :onSearch="(search) => debouncedOnSearch(search, j)"
                                    />
                                </div>
                                <b-checkbox
                                    v-if="app_modulo.app_telaList.length > 1"
                                    v-model="app_modulo.allSelected"
                                    @input="(value) => selectAllCheckbox(app_modulo, value)"
                                >
                                    {{ $t('todos') }}
                                </b-checkbox>

                                <div v-for="(app_tela, k) in app_modulo.app_telaList" :key="k">
                                    <b-checkbox
                                        v-model="app_modulo.app_telaList[k].allpermissions"
                                        :indeterminate="app_modulo.app_telaList[k].somepermissions"
                                        @input="
                                            (val) => {
                                                controlSelection(
                                                    app_modulo,
                                                    app_modulo.app_telaList[k],
                                                    val
                                                );
                                            }
                                        "
                                        v-show="app_tela.show"
                                    >
                                        {{ $t(app_tela.nome) }}
                                    </b-checkbox>
                                    <div
                                        class="permission-individual"
                                        v-if="showPermisssions(app_tela, j, k)"
                                    >
                                        <b-checkbox
                                            type="is-primary"
                                            v-model="
                                                app_modulo.app_telaList[k].perm_perfilacessotelas
                                                    .read
                                            "
                                            @input="
                                                (val) => {
                                                    controlPermissions(
                                                        app_modulo,
                                                        app_modulo.app_telaList[k],
                                                        val,
                                                        'read'
                                                    );
                                                }
                                            "
                                        >
                                            {{ $t('read') }}
                                        </b-checkbox>
                                        <b-checkbox
                                            type="is-primary"
                                            v-model="
                                                app_modulo.app_telaList[k].perm_perfilacessotelas
                                                    .update
                                            "
                                            @input="
                                                (val) => {
                                                    controlPermissions(
                                                        app_modulo,
                                                        app_modulo.app_telaList[k],
                                                        val,
                                                        'update'
                                                    );
                                                }
                                            "
                                        >
                                            {{ $t('update') }}
                                        </b-checkbox>
                                        <b-checkbox
                                            type="is-primary"
                                            v-model="
                                                app_modulo.app_telaList[k].perm_perfilacessotelas
                                                    .create
                                            "
                                            @input="
                                                (val) => {
                                                    controlPermissions(
                                                        app_modulo,
                                                        app_modulo.app_telaList[k],
                                                        val,
                                                        'create'
                                                    );
                                                }
                                            "
                                        >
                                            {{ $t('create') }}
                                        </b-checkbox>
                                        <b-checkbox
                                            type="is-primary"
                                            v-model="
                                                app_modulo.app_telaList[k].perm_perfilacessotelas
                                                    .delete
                                            "
                                            @input="
                                                (val) => {
                                                    controlPermissions(
                                                        app_modulo,
                                                        app_modulo.app_telaList[k],
                                                        val,
                                                        'delete'
                                                    );
                                                }
                                            "
                                        >
                                            {{ $t('delete') }}
                                        </b-checkbox>
                                        <b-checkbox
                                            type="is-primary"
                                            v-model="
                                                app_modulo.app_telaList[k].perm_perfilacessotelas
                                                    .export
                                            "
                                            @input="
                                                (val) => {
                                                    controlPermissions(
                                                        app_modulo,
                                                        app_modulo.app_telaList[k],
                                                        val,
                                                        'export'
                                                    );
                                                }
                                            "
                                        >
                                            {{ $t('export') }}
                                        </b-checkbox>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Message from '@/models/Message';
import { mapState } from 'vuex';

export default {
    components: {
        Message,
    },
    props: {
        perm_perfilacessotelas: {
            type: Object,
            default: () => {},
        },
        abaSelecionada: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            moduloPai: {},
            moduloPaiCopy: {},
            isSaving: false,
            saved: false,
            debouncedOnSearch: null,
            isAdmin: false,
            isUpdate: false,
            goToNewRoute: false,
            afterSave: false,
            app_moduloList: [],
            showContexto: false,
            abaSelecionadaInner: null,
        };
    },
    created() {
        this.abaSelecionadaInner = { ...this.abaSelecionada };
        this.debouncedOnSearch = this.debounce(this.filterView, 500);
        this.findModulosFilhosByModuloPaiEPerfil();
    },
    computed: {
        ...mapState(['app_modulo']),
    },

    methods: {
        findModulosFilhosByModuloPaiEPerfil() {
            // busca todas as app_telaList do módulo juntamente com as permissões caso tenha
            this.$store.commit('addLoader');
            this.isLoading = true;

            this.$axios
                .get(
                    `controle/app/app_modulo/modulosbymodulopai.json?idmodulopai=${this.abaSelecionadaInner.id}&idperfilacesso=${this.$route.params.id}`
                )
                .then((response) => {
                    this.app_moduloList = response.data.content;
                })
                .catch((e) => {
                    this.app_moduloList = [];
                    console.error('Ocorreu um erro ao buscar módulos e telas: ', { e });
                })
                .finally(() => {
                    this.isLoading = false;
                    this.$store.commit('removeLoader');
                    this.configModules();
                });
        },
        configModules() {
            // mostrar os dados caso tenha permissão ao módulo
            let temp = this.app_modulo.data.app_moduloList.find(
                (f) => f.nome == this.abaSelecionadaInner.nome
            );
            this.showContexto = temp != undefined;

            // monta o objeto para trabalhar internamente
            // filtra pela configuração de mostrar edição de permissões
            this.app_moduloList = this.app_moduloList.filter(
                (app_modulo) => app_modulo.mostrarconfig == 1
            );
            this.app_moduloList.forEach((app_modulo, index2) => {
                if (this.abaSelecionadaInner.nome != 'admin' && app_modulo.ordem <= 0) {
                    return;
                }
                app_modulo.isOpen = false;
                app_modulo.countSelected = 0;

                app_modulo.app_telaList = app_modulo.app_telaList.filter(
                    (app_tela) => app_tela.mostrarconfig == 1
                );

                app_modulo.app_telaList.forEach((app_tela) => {
                    app_tela.show = 1;
                    if (!app_tela.perm_perfilacessotelas) {
                        app_tela.perm_perfilacessotelas = {
                            create: false,
                            delete: false,
                            export: false,
                            read: false,
                            update: false,
                        };
                    }

                    if (
                        app_tela.perm_perfilacessotelas.read &&
                        app_tela.perm_perfilacessotelas.create &&
                        app_tela.perm_perfilacessotelas.delete &&
                        app_tela.perm_perfilacessotelas.export &&
                        app_tela.perm_perfilacessotelas.update
                    ) {
                        app_modulo.countSelected++;
                        app_tela.somepermissions = false;
                        app_tela.allpermissions = true;
                    } else if (
                        app_tela.perm_perfilacessotelas.read ||
                        app_tela.perm_perfilacessotelas.create ||
                        app_tela.perm_perfilacessotelas.delete ||
                        app_tela.perm_perfilacessotelas.export ||
                        app_tela.perm_perfilacessotelas.update
                    ) {
                        app_modulo.countSelected++;
                        app_tela.somepermissions = true;
                        app_tela.allpermissions = false;
                    } else {
                        app_tela.somepermissions = false;
                        app_tela.allpermissions = false;
                    }
                });
                if (app_modulo.countSelected == app_modulo.app_telaList.length) {
                    app_modulo.allSelected = true;
                }
            });
            this.$forceUpdate();
        },
        showPermisssions(app_tela, j, k) {
            // mostra as permissões caso tenha
            return (
                app_tela.show &&
                (this.app_moduloList[j].app_telaList[k].allpermissions ||
                    this.app_moduloList[j].app_telaList[k].somepermissions)
            );
        },
        onOpen(app_modulo, val) {
            // console.log('onOpen', app_tela);
            app_modulo.isOpen = val;
            this.$forceUpdate();
        },
        controlSelection(app_modulo, screen, value) {
            // console.log('controlSelection', app_modulo, screen, value);
            this.$emit('isChanged', true);
            app_modulo.countSelected = this.countSelectedCheckbox(app_modulo);
            if (
                app_modulo.app_telaList.length > 1 &&
                app_modulo.countSelected == app_modulo.app_telaList.length
            ) {
                app_modulo.allSelected = true;
            } else {
                app_modulo.allSelected = false;
            }

            screen.perm_perfilacessotelas.read = value;
            screen.perm_perfilacessotelas.update = value;
            screen.perm_perfilacessotelas.create = value;
            screen.perm_perfilacessotelas.delete = value;
            screen.perm_perfilacessotelas.export = value;
            screen.somepermissions = false;

            this.$forceUpdate();
        },
        countSelectedCheckbox(app_modulo) {
            // console.log('countSelectedCheckbox', app_modulo);
            let count = 0;
            app_modulo.app_telaList.forEach((app_tela) => {
                if (app_tela.allpermissions || app_tela.somepermissions) {
                    count++;
                }
            });
            return count;
        },
        selectAllCheckbox(app_modulo, val) {
            // seleciona todas as permissões
            this.$emit('isChanged', true);
            app_modulo.app_telaList.forEach((app_tela) => {
                app_tela.allpermissions = val;
                app_tela.somepermissions = false;
                app_tela.perm_perfilacessotelas.read = val;
                app_tela.perm_perfilacessotelas.update = val;
                app_tela.perm_perfilacessotelas.create = val;
                app_tela.perm_perfilacessotelas.delete = val;
                app_tela.perm_perfilacessotelas.export = val;
            });

            app_modulo.countSelected = this.countSelectedCheckbox(app_modulo);
            this.$forceUpdate();
        },
        controlPermissions(app_modulo, app_tela, val, permission) {
            // console.log('controlPermissions', app_tela, app_tela, val, permission);
            this.$emit('isChanged', true);
            if (
                app_tela.perm_perfilacessotelas.read &&
                app_tela.perm_perfilacessotelas.update &&
                app_tela.perm_perfilacessotelas.create &&
                app_tela.perm_perfilacessotelas.delete &&
                app_tela.perm_perfilacessotelas.export
            ) {
                app_tela.somepermissions = false;
                app_tela.allpermissions = true;
            } else if (
                app_tela.perm_perfilacessotelas.read ||
                app_tela.perm_perfilacessotelas.update ||
                app_tela.perm_perfilacessotelas.create ||
                app_tela.perm_perfilacessotelas.delete ||
                app_tela.perm_perfilacessotelas.export
            ) {
                app_tela.somepermissions = true;
                app_tela.allpermissions = false;
                if (permission != 'read' && val) {
                    app_tela.perm_perfilacessotelas.read = true;
                } else if (permission == 'read' && !val) {
                    app_tela.somepermissions = false;
                    app_tela.perm_perfilacessotelas.update = val;
                    app_tela.perm_perfilacessotelas.create = val;
                    app_tela.perm_perfilacessotelas.delete = val;
                    app_tela.perm_perfilacessotelas.export = val;
                    app_modulo.countSelected = this.countSelectedCheckbox(app_modulo);
                }
            } else {
                app_tela.somepermissions = false;
                app_tela.allpermissions = false;
                app_tela.perm_perfilacessotelas.read = false;
            }
            this.$forceUpdate();
        },
        filterView(search, j) {
            if (search != '') {
                this.app_moduloList[j].app_telaList = this.app_moduloList[j].app_telaList.map(
                    (x) => {
                        x.show = 0;
                        if (x.nome.toLowerCase().includes(search.toLowerCase())) {
                            x.show = 1;
                        }
                        return x;
                    }
                );
            } else {
                this.app_moduloList[j].app_telaList = this.app_moduloList[j].app_telaList.map(
                    (x) => {
                        x.show = 1;
                        return x;
                    }
                );
            }
            this.$forceUpdate();
        },
        savePerfil() {
            this.$store.commit('addLoader');
            this.isSaving = true;
            let isSuccess = true;
            const pilhaModulos = [];
            // Gerando os registros de perfil acesso para cada tela de cada modulo.
            this.app_moduloList.forEach((app_modulo) => {
                const perfilacessotelas = [];
                pilhaModulos.push(0);

                app_modulo.app_telaList.forEach((app_tela) => {
                    perfilacessotelas.push({
                        idtela: app_tela.id,
                        idperfilacesso: this.$route.params.id,
                        idperfilacessotelas: app_tela.perm_perfilacessotelas.idperfilacessotelas
                            ? app_tela.perm_perfilacessotelas.idperfilacessotelas
                            : null,
                        read: app_tela.perm_perfilacessotelas.read,
                        create: app_tela.perm_perfilacessotelas.create,
                        update: app_tela.perm_perfilacessotelas.update,
                        delete: app_tela.perm_perfilacessotelas.delete,
                        export: app_tela.perm_perfilacessotelas.export,
                    });
                });

                /** @ Foi mantido as requisições dessa forma em
                 * lotes pois fica mais rapido enviar em multiprocessamento
                 * e não corre risco de time-out de outros serviços
                 * Futuras correções: validar somente os itens que
                 * foram alterados e deixar a par com o banco e
                 * somente atualizar os valores corretos
                 **/
                this.$axios
                    .post('config/access-profile/perm_perfilacessotelas', perfilacessotelas)
                    .then((response) => {
                        if (response.data.content) {
                            this.$emit('isChanged', false);
                        } else {
                            isSuccess = false;
                            if (this.$t(response.data.message)) {
                                this.$root.showMessage('error', response.data.message);
                            } else {
                                this.$root.showMessage('error', 'msg-problema-realizar-acao');
                            }
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');
                        isSuccess = false;
                    })
                    .finally(() => {
                        pilhaModulos.pop();

                        if (pilhaModulos.length == 0) {
                            this.isSaving = false;
                            this.$store.commit('removeLoader');

                            if (isSuccess) {
                                this.$root.showMessage('success', 'msg-perfil-editado');
                            }
                            this.findModulosFilhosByModuloPaiEPerfil();
                        }
                    });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.modulo-container {
    .collapse {
        display: block;
    }
    .checkbox-group {
        padding: 0.5em 0.75em;
    }

    .modulo-telas {
        width: 100%;
        padding: 10px;
        margin: 0px;
    }

    .modulo-collapse {
        width: 100%;
        margin-bottom: 20px;
        margin-right: 1%;

        .module-title-block {
            display: flex;
            color: var(--primary-color);
            flex-grow: 1;
            flex-shrink: 1;
            border-radius: 8px;
            box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
                0 1px 3px 0 rgba(0, 0, 0, 0.12);
            padding: 5px;
            background-color: $sovis-white;

            &.modulo-opened {
                border-radius: 8px 8px 0 0;
            }

            .left {
                flex-grow: 1;
                padding: 5px;
            }

            .right {
                width: 70px;
                display: flex;

                .number-box {
                    padding: 5px;
                    background-color: var(--primary-color-click);
                    color: $sovis-white;
                    margin-right: 5px;
                    flex-grow: 1;
                    text-align: center;
                    border-radius: 8px;

                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .icon-box {
                    padding: 5px;
                }
            }
        }

        .checkbox-group {
            padding: 5px;
            border-radius: 0 0 8px 8px;
            box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
                0 1px 3px 0 rgba(0, 0, 0, 0.12);
            background-color: $sovis-white;

            .group-search {
                padding: 5px;

                .search-wrapper {
                    border-radius: 5px;
                }
            }

            .permission-individual {
                display: flex;
                flex-wrap: wrap;
                padding: 10px;
                background: $darker-bg-color;
                border-radius: 8px;

                > .b-checkbox {
                    width: 30%;
                    padding: 3px;
                }
            }
        }
    }
}
</style>
